<template>
    <div class="devicesetting">
        <el-form ref="form" :model="relayform" label-width="90px" label-position="left" class="relayform-content">
            <el-form-item label="站点选择：">
                <el-select v-model="relayform.siteno" placeholder="请选择" class="site-list"
                    @change="siteChangeHandle" v-if="sitesList">
                    <el-option v-for="item in sitesList"
                    :key="item.siteno"
                    :label="item.sitename"
                    :value="item.siteno">
                    </el-option>
                </el-select>

                <el-button class="form-right" type="primary" icon="el-icon-refresh" circle @click="siteChangeHandle"></el-button>

                <!--站点是否可用-->
                <div class="relay-message" v-if="!siteEnable">
                    <i class="iconfont icon-weixian"></i>
                    <span class="label">站点状态：</span>
                    <span>{{siteEnable?"可用":"不可用"}}</span>
                    <span class="label">操作状态：</span>
                    <span>{{relayform.remoteStatus==102?"操作进行中":"等待命令"}}</span>
                </div>

            </el-form-item>

            <el-form-item label="设备状态：" class="relaystatus">
                <span class="status">{{remoteSiteRelayStatus}}</span>
                <span class="time">{{remoteSiteStatusTime}}</span>
                <el-button size="small" type="primary" @click="updateStatus" :disabled="!siteEnable">读取</el-button>
            </el-form-item>

            <el-form-item label="设备操作：">
                <el-radio-group v-model="relayform.relaycontrol">
                    <el-radio label="open">开</el-radio>
                    <el-radio label="close">关</el-radio>
                    <el-radio label="auto">自动</el-radio>
                </el-radio-group>

                <el-button size="small" type="primary" @click="updateRelayControl" :disabled="!siteEnable">写入</el-button>
            </el-form-item>
        </el-form>

        <!--不可充值-->
        <div class="msg-wrap" v-if="!siteEnable">
            <div class="msg-content"><i class="iconfont icon-weixian"></i>无法进行操作</div>
        </div>
    </div>
</template>

<script>
import {getDeviceData} from "@api/billing";
import {relayControl,getRelayStatus,updateRelayStatus} from "@api/relaycontrol";
/**
 * 设备开关
 */
export default {
    name:"relaycontrol",
    props:["sitesList"],
    data(){
        return {
            relayform:{
                siteno:-1, // 站点编号
                remoteAvaliable:0,// 设备是否可用
                remoteStatus:0, // 远程设备状态
                remoteRelayControl:"未知", // 最后的传感器状态
                update_time:"",// 状态更新时间
                relaycontrol:"auto", // 设备开关状态
            }, // 设备数据
        }
    },
    computed:{
        // 站点是否可用，当远程状态码为5xx,201或者202，并且remoteAvaliable==1的时候，站点可用
        siteEnable(){
            let r=this.relayform;
            if(r.remoteAvaliable==1&&(r.remoteStatus==201||r.remoteStatus==202||r.remoteStatus>=500)){
                return true;
            }
            return false;
        },
        // 远程设备最后的状态
        remoteSiteRelayStatus(){
            let result="未知";
            switch(this.relayform.remoteRelayControl){
                case "auto":
                    result="自动";
                    break;
                case "open":
                    result="开";
                    break;
                case "close":
                    result="关";
                    break;
            }
            return result;
        },
        // 更新时间
        remoteSiteStatusTime(){
            let nowTime=this.$moment();
            let time=nowTime.format('MM-DD HH:mm:ss'); // 开时日期
            let siteTime=this.relayform.update_time;
            if(siteTime){
                time=this.$moment(siteTime).format('MM-DD HH:mm:ss');
            }
            return time;
        }
    },
    mounted(){
        // 选中第一个
        let sites=this.sitesList;
        let first=Object.keys(sites)[0];
        this.$set(this.relayform,"siteno",sites[first].siteno);
        // 获取站点是否可用
        this.getDeviceData();

        // 监听状态刷新消息
        this.$bus.$on("updateRelayStatus",this.getDeviceStatus);
    },
    methods:{
        // 站点选择改变
        siteChangeHandle(){
            this.getDeviceData();
        },
         // 获取设备数据
        getDeviceData(site){
            let siteno=this.relayform.siteno;
            if(site){
                siteno=site.siteno;
            }
            // 查询设备信息
            if(siteno||siteno==0){
                getDeviceData(siteno).then(res=>{
                    if(res.status&&res.status==200){
                        let content=res.content;
                        let remote_status=content.remote_status; // 远程状态
                        let remote_Avaliable=0;
                        if(remote_status==201||remote_status==202||remote_status>=500){
                            remote_Avaliable=content.remote_avaliable;
                        }else{
                            remote_Avaliable=0;
                        }

                        // 站点不可用
                        this.$set(this.relayform,"remoteAvaliable",remote_Avaliable);
                        this.$set(this.relayform,"remoteStatus",remote_status);

                        // 如果传入的站点存在
                        if(site){
                            site.remoteStatus=remote_status;
                            site.remoteAvaliable=remote_Avaliable;
                        }
                    }
                });
                // 获取远程站点状态
                this.getDeviceStatus();
            }
        },

        // 查询设备是否在线
        getDeviceStatus(site){
            let siteno=this.relayform.siteno;
            if(site){
                siteno=site.siteno;
            }
            // 查询设备信息
            if(siteno||siteno==0){
                getRelayStatus(siteno).then(res=>{
                    if(res.status&&res.status==200){
                        let content=res.content;
                        let RelayControl=content.RelayControl; // 远程状态
                        let update_time=content.update_time;

                        // 设置状态
                        this.$set(this.relayform,"remoteRelayControl",RelayControl);
                        this.$set(this.relayform,"update_time",update_time);
                        this.$set(this.relayform,"relaycontrol",RelayControl);

                        // 如果传入的站点存在
                        if(site){
                            site.RelayControl=RelayControl;
                            site.update_time=update_time;
                        }
                    }else{
                        let update_time=this.$moment().format('yyyy-MM-DD HH:mm:ss');
                        // 设置状态
                        this.$set(this.relayform,"remoteRelayControl","");
                        this.$set(this.relayform,"update_time",update_time);
                        this.$set(this.relayform,"relaycontrol","");
                    }
                });
            }
        },
        // 更新寄存器开关操作
        updateRelayControl(){
            let siteno=this.relayform.siteno;
            let relaycontrol=this.relayform.relaycontrol; // 状态
            // 执行操作
            relayControl(siteno,relaycontrol,"").then(res=>{
                if(res.status&&res.status==200){
                    // 触发进度处理
                    this.$bus.$emit("processing","relaycontrol");
                    // 刷新数据列表
                    this.$bus.$emit("updateRelayRecord");
                }
            })
        },
        // 更新寄存器的状态
        updateStatus(){
            let siteno=this.relayform.siteno;
            // 执行操作
            updateRelayStatus(siteno).then(res=>{
                if(res.status&&res.status==200){
                    // 重新获取远程站点状态
                    this.getDeviceStatus();
                    // 触发进度处理
                    this.$bus.$emit("processing","relaystatus");
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
/** 充值 */
.devicesetting{

    .relayform-content{
        padding:0 50px;

        .site-list{
            width: 180px;
        }

        ::v-deep .el-form-item{
            button{
                margin-left: 10px;
            }
        }
        ::v-deep .relaystatus{
            .status{

            }
            .time{
                margin-left: 10px;
                font-size: 12px;
            }
        }
    }

    .form-right{
        margin-left: 10px;
    }

    .btn-array{
        text-align: center;
    }

    // 站点状态
    .relay-message{
        color: red;
        padding: 0;
        line-height: initial;
        margin: 5px 0 0 0;
        font-size: 12px;
        text-align: left;

        i{
            vertical-align: text-bottom;
        }

        .label{
            margin-left: 5px;
        }
    }
    /** 不可操作 */
    .msg-wrap{ 
        position: absolute;
        top: 0;
        left: 0;

        .msg-content{
            position: absolute;
            background: #fff;
            height: 100px;
            text-align:center;
            line-height:100px;
            left: 100px;
            top: 140px;
            width: 200px;
            border: 1px solid;
            border-radius: 5px;
            color: red;
        }
        
    }
}
</style>